/**
 * Laufende Schreibvorgaenge der Firmeneinstellungen (AdminGlobalSettings).
 *
 * Modulweit, weil der letzte Schreibvorgang erst beim Aushaengen startet
 * (offener Autosave) — die Komponente ist dann schon weg. Die AdminView
 * wartet darauf, bevor sie das Profil liest: wer die Verwaltung verlaesst und
 * sofort zurueckkommt, bekaeme sonst das Profil von VOR dem Schreiben, und die
 * neue Instanz schriebe mit der naechsten Aenderung einen ganzen Block
 * (invoiceConfig) mit Altwerten zurueck.
 *
 * Eigene Datei statt Export aus der Komponente: Fast Refresh verlangt, dass
 * eine Komponentendatei nur Komponenten exportiert.
 */
const laufend = new Set<Promise<void>>();

/** Meldet einen Schreibvorgang an; der Rueckgabewert meldet ihn wieder ab. */
export const schreibvorgangBeginnt = (): (() => void) => {
    let fertig: () => void = () => {};
    const lauf = new Promise<void>((resolve) => { fertig = resolve; });
    laufend.add(lauf);
    return () => {
        laufend.delete(lauf);
        fertig();
    };
};

/** Erfuellt sich, sobald alle JETZT laufenden Schreibvorgaenge fertig sind. */
export const einstellungenGeschrieben = (): Promise<void> =>
    Promise.all([...laufend]).then(() => undefined);
